import { InfoIcon } from "lucide-react";
import { ClipboardIcon, CheckIcon } from "lucide-react";
import { useState } from "react";

export const TemporaryPasswordField = ({ randomPass }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(randomPass);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative rounded-radius border border-border bg-background/60 p-3 flex flex-col gap-1">
      {/* Upper-right hint with info icon */}
      <div className="absolute top-2 right-3 flex items-center gap-1 text-[10px] text-muted-foreground">
        <InfoIcon className="w-3 h-3 text-green-500" />
        <span>Login & change password</span>
      </div>

      <p className="text-xs uppercase tracking-wide text-muted-foreground">
        TEMPORARY PASSWORD
      </p>

      <div className="flex items-center justify-between">
        <p className="text-sm text-foreground font-medium">{randomPass}</p>

        <button
          onClick={handleCopy}
          className="ml-2 p-1.5 rounded-md border border-border bg-background hover:bg-background/80 transition flex items-center"
        >
          {copied ? (
            <CheckIcon className="w-4 h-4 text-green-500" />
          ) : (
            <ClipboardIcon className="w-4 h-4 text-foreground" />
          )}
        </button>
      </div>
    </div>
  );
};
